import type { User } from 'src/contracts/auth';

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  token: string | null;
  user: User | null;
  roles: string[];
  setAuth: (token: string, user: User, roles: string[]) => void;
  updateUser: (user: Partial<User>) => void;
  clearAuth: () => void;
  isAuthenticated: () => boolean;
  isAdmin: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      roles: [],
      setAuth: (token, user, roles) => set({ token, user, roles }),
      updateUser: (partial) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...partial } : null,
        })),
      clearAuth: () => set({ token: null, user: null, roles: [] }),
      isAuthenticated: () => !!get().token,
      isAdmin: () => get().roles.includes('Admin'),
    }),
    { name: 'jj-auth' }
  )
);
